import {
  call, put, takeEvery, select,
} from 'redux-saga/effects';

import HttpClient from 'circe/Http/HttpClient';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { show as showNotification } from 'circe/notifications/actions';
import actionTypes from './actionTypes';

import { failed, fetched } from './actions';

const errorMessageExtractorFunction = (response) => (response && response.message ? response.message : null);

function* doFetch(action) {
  const { reducerName, payload } = action;

  const { url, params = {}, options = {} } = payload;

  const {
    errorMessage,
    errorMessageExtractor = errorMessageExtractorFunction,
    showErrorNotification = true,
  } = options;

  const state = yield select();

  const headers = yield call(getCurrentAuthHeader, state);

  try {
    const client = new HttpClient().withBeforeHook((options) => {
      options.headers = headers;
      return options;
    });

    const data = yield client
      .Get(url)
      .withParams(params)
      .send();

    yield put(fetched({ reducerName, data }));
  } catch (e) {
    const message = errorMessage || errorMessageExtractor(e.response, e.status, e);

    if (showErrorNotification && message) {
      yield put(showNotification(message, 'error'));
    }

    yield put(failed({ reducerName }));
  }
}

export default function* () {
  yield takeEvery(actionTypes.FETCH, doFetch);
}
